<template>
  <div>
    <div class="header">
      <a-menu
        style="text-align: center; border-bottom: 0px"
        :default-selected-keys="['baseSetting']"
        active-text-color="#409eff"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect">
        <a-menu-item key="baseSetting" @click="to('baseSetting')">① 基础信息</a-menu-item>
        <!-- <a-menu-item key="formSetting" @click="to('formSetting')">② 审批表单</a-menu-item>-->
        <a-menu-item key="processDesign" @click="to('processDesign')">② 审批流程</a-menu-item>
        <!-- <a-menu-item key="proSetting" @click="to('proSetting')">④ 扩展设置</a-menu-item>-->
      </a-menu>
      <div class="publish">
        <span v-if="versionList.length > 0">
          <a-dropdown placement="bottomLeft">
            <a class="ant-dropdown-link">
              当前版本：
              <a-tag color="green">
                v{{ currentVersion }}
                <a-icon type="down" />
              </a-tag>
            </a>
            <a-menu slot="overlay" @click="showVersion" >
              <a-menu-item v-for="item in versionList" :key="item.id" divided>
                <span>
                  <span>
                    {{ item.template_name}}
                  </span>
                  <a-tag color="green">
                    v{{ item.version }}
                  </a-tag>
                </span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <a-button v-if="false" size="default" @click="preview"><i class="el-icon-view"></i>预览</a-button>
        <a-button size="default" type="primary" @click="publish"><i class="el-icon-s-promotion"></i>发布</a-button>
      </div>
      <div class="back">
        <a-button @click="exit" icon="arrow-left" shape="round">返回</a-button>
        <span style="padding-left: 10px">
<!--          <i :class="setup.logo.icon" :style="'background:' + setup.logo.background"></i>-->
          <span>{{ setup.formName }}</span>
        </span>
      </div>
    </div>

    <el-dialog title="请使用手机扫码预览" :visible.sync="viewCode" width="300px" :close-on-click-modal="false" center>
      <img src="../../../../assets/image/code.png" width="250" height="250">
    </el-dialog>
  </div>
</template>

<script>

import { getFormVersion } from '@/api/oa_approve'
import { Modal } from 'ant-design-vue'
import { mapMutations } from 'vuex'

export default {
  name: 'LayoutHeader',
  props: {
    value: {
      type: String,
      default: 'baseSetting'
    }
  },
  data () {
    return {
      viewCode: false,
      currentVersion: '',
      versionList: []
    }
  },
  computed: {
    setup () {
      return this.$store.state.oaApprove.design
    }
  },
  created () {
    this.check()
  },
  mounted () {
    console.log(document.body.offsetWidth)
    if (document.body.offsetWidth <= 970) {
      this.$msgbox.alert('本设计器未适配中小屏幕，建议您在PC电脑端浏览器进行操作')
    }
    this.listener()
    this.showVersion(undefined)
  },
  methods: {
    ...mapMutations('oaApprove', ['loadForm']),
    publish () {
      this.$emit('publish')
    },
    preview () {
      this.$emit('preview')
      // this.
      this.viewCode = true
    },
    showVersion (v) {
      console.log(this.$route.query.code, v)
      if (this.$route.query.code === undefined) {
        return
      }
      const id = v !== undefined ? v.key : undefined
      getFormVersion({ template_id: this.$route.query.code, id: id }).then(res => {
        if (res.code === 1000) {
          if (id === undefined) {
            this.versionList = res.data.entries
            if (this.versionList.length > 0) {
              this.currentVersion = this.versionList[0].version
            }
          } else if (res.data.entries.length > 0) {
            this.currentVersion = res.data.entries[0].version
            this.$emit('reLoadData', res.data.entries[0])
          }
        }
      })
    },
    valid () {
      if (!this.$isNotEmpty(this.setup.group)) {
        this.$message.warning('请选择分组')
        this.$router.push('/layout/baseSetup')
        return false
      }
      return true
    },
    exit () {
      Modal.confirm({
        title: this.$t('提示'),
        content: this.$t('未发布的内容将不会被保存，是否直接退出 ?'),
        onOk: () => {
          this.$router.back()
        }
      })
    },
    to (path) {
      this.$emit('input', path)
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    listener () {
      window.onunload = this.closeBefore()
      window.onbeforeunload = this.closeBefore()
      // window.on('beforeunload',this.closeBefore())
    },
    closeBefore () {
      // alert("您将要离开本页")
      return false
    },
    check () {
      if (this.$store.state.oaApprove.isEdit === null) {
        // this.$router.push("/workPanel");
      }
    },
    loadFormInfo (formInfo) {
      // form.logo = JSON.parse(form.logo)
      formInfo.formId = formInfo.id
      formInfo.formName = formInfo.template_name
      // form.category = this.getCategoryName(form.category)
      formInfo.groupId = formInfo.group_id
      formInfo.group_id = undefined
      formInfo.settings = JSON.parse(formInfo.settings)
      formInfo.formItems = JSON.parse(formInfo.form_items)
      formInfo.process = JSON.parse(formInfo.process)
      this.formData = formInfo
      // this.$store.commit('loadForm', formInfo)
      this.loadForm(formInfo)
    }
  }
}
</script>
<style lang="less" scoped>

/deep/ .header {
  min-width: 100%;
  position: relative;

  .el-menu {
    top: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .publish {
    position: absolute;
    top: 0px;
    right: 20px;
    z-index: 1000;
    height: 50px;
    line-height: 50px;

    i {
      margin-right: 6px;
    }

    button {
      border-radius: 15px;
    }
  }

  .back {
    position: absolute;
    z-index: 1000;
    top: 0px;
    left: 20px;
    font-size: small;
    height: 50px;
    line-height: 50px;

    span {
      i {
        border-radius: 10px;
        padding: 7.8px;
        font-size: 20px;
        color: #ffffff;
        margin: 0 10px;
      }
    }

  }
}
</style>
